module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/FrontDay/Nagano_FrontDay_MRI_RCP85_End.png";